import * as yup from 'yup';
import { legalFirstNameValidation, legalLastNameValidation } from '../../fields/Name/Name.meta';
import { emailValidation } from '../../fields/Email/Email.meta';
import {
  cityValidation,
  postalCodeValidation,
  stateValidation,
  streetAddressLine1Validation,
} from '../../fields/Address/Address.meta';
import { dobValidation } from '../../fields/DateOfBirth/DateOfBirth.meta';
import { ssnValidation } from '../../fields/Ssn/Ssn.meta';
import { phoneNumberValidation } from '../../fields/Phone/Phone.meta';

export const validation = yup.object().shape({
  legalFirstName: legalFirstNameValidation,
  legalLastName: legalLastNameValidation,
  email: emailValidation,
  streetAddressLine1: streetAddressLine1Validation,
  city: cityValidation,
  state: stateValidation,
  postalCode: postalCodeValidation,
  dob: dobValidation,
  ssn: ssnValidation,
  phoneNumber: phoneNumberValidation,
});
